import type {
  ChannelThreadId,
  SupportTicketId,
} from "@redotech/effect-api-shared/ids/definitions";
import type { Message } from "@redotech/effect-api-shared/models/shopper-ai/conversation/message";
import type { ChannelThread } from "@redotech/effect-api-shared/models/shopper-ai/conversation/thread";
import { memo } from "react";
import { ChatMessageBubble } from "../message-types/chat-message-bubble";
import { MetaCommentChatMessageBubble } from "../message-types/meta-comment-chat-message-bubble";
import { ChatThreadView } from "./chat-thread-view";

interface InstagramThreadViewProps {
  messages: Message[];
  supportTicketId: SupportTicketId;
  thread: ChannelThread;
}

export const InstagramThreadView = memo(function InstagramThreadView({
  messages,
  supportTicketId,
  thread,
}: InstagramThreadViewProps) {
  return (
    <ChatThreadView
      channel={thread.channel}
      messages={messages}
      renderMessage={(msg: Message, threadId: ChannelThreadId) => {
        // Instagram comments use MetaCommentChatMessageBubble for like/hide actions
        // Instagram DMs use regular ChatMessageBubble
        if (msg.channel === "instagramComments") {
          return (
            <MetaCommentChatMessageBubble
              channel={thread.channel}
              message={msg}
              supportTicketId={supportTicketId}
              threadId={threadId}
            />
          );
        }

        return <ChatMessageBubble message={msg} />;
      }}
      supportTicketId={supportTicketId}
      thread={thread}
    />
  );
});
